import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"down\">\n    <g fill=\"currentColor\" fill-rule=\"evenodd\">\n        <path fill=\"currentColor\" d=\"M8 9.25L3.75 5 3 5.75 8 10.75 13 5.75 12.25 5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol